const buttons = {
	add: "Hinzufügen",
	add_qemu: "VPS hinzufügen",
	block: "Blockieren",
	calculate: "Berechnen",
	cancel: "Abbrechen",
	change_template: "Vorlage ändern",
	check: "Siehe",
	choose: "Konfigurieren",
	close: "Schließen",
	confirm: "Bestätigen",
	connect: "Link",
	copied: "Kopiert!",
	copy: "Kopieren",
	create: "Erstellen",
	deblock: "Entsperren",
	delete: "Löschen",
	details: "Einzelheiten",
	disconnect: "Trennen",
	edit: "Bearbeiten",
	get_details: "Details abrufen",
	leave: "Verlassen",
	more_info: "Mehr Informationen",
	next: "Weiter",
	order: "befehlen",
	previous: "Zurück",
	resend: "Erneut senden",
	reset: "Zurücksetzen",
	save: "Speichern",
	search: "Suchen",
	select: "Auswählen",
	selected: "Ausgewählt",
	send: "Senden",
	show_details: "Details anzeigen",
	sign_in: "Anmelden",
	sign_in_return: "Zurück zur Anmeldeseite",
	sign_up: "Registrieren",
	start_tour: "Tour starten",
	update: "Ändern",
	view: "Anzeigen",
};

export default buttons;
